import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { Typography } from '@chilecompra/react-kit/components'
import { formatPercentage } from '../../modules/utils/formatters'
import { onContractDivisionsThunk } from './ContractDivisions.actions'
import DonutChart from '../../components/Charts/DonutChart'
import ContractDivisionNoInfo from '../../components/Errors/ContractDivisionNoInfo'
import { GridWrapper, ContractNumberLabel } from './ContractDivisions.styles'

/**
 * The ContractDivisions' container.
 */
const ContractDivisions = props => {
  const { year } = props
  const dispatch = useDispatch()
  const { idEntity } = useSelector(state => state.buyerSection)
  const {
    data: { Assets, Inm, OtherCat, OtherEj, Services, Time }
  } = useSelector(state => state.contractDivisions)
  const { loading: initialLoading } = useSelector(state => state.topNavbar)

  useEffect(() => {
    if (!idEntity || initialLoading) {
      return
    }

    dispatch(onContractDivisionsThunk(idEntity, year))
  }, [initialLoading, idEntity])

  const contractCategoryTotal = (Assets.value || 0) + (Services.value || 0) + (OtherCat.value || 0)
  const contactExecutionTotal = (Inm.value || 0) + (Time.value || 0) + (OtherEj.value || 0)

  return (
    <GridWrapper container justifyContent="flex-start" margin="48px auto 0 auto">
      <GridWrapper item xs={12} md={6}>
        <Typography variant="h4" fontSize="16px" fontWeight="bold" align="left">
          Fichas de contrato por categoría
          <ContractNumberLabel>{contractCategoryTotal}</ContractNumberLabel>
        </Typography>
        {contractCategoryTotal === 0 ? (
          <GridWrapper item xs={12} margin="16px 0 0 0">
            <ContractDivisionNoInfo errorText="No existe información asociada a contratos por categoría" />
          </GridWrapper>
        ) : (
          <GridWrapper container justifyContent="flex-start" margin="10px auto 0 auto">
            <GridWrapper item xs={12} sm={4}>
              <GridWrapper container alignItems="center">
                <GridWrapper item xs={6}>
                  <DonutChart color="cinnabar" value={Assets.percentage} />
                </GridWrapper>
                <GridWrapper item xs={6}>
                  <Typography fontSize="12px" fontWeight="bold" margin="0" variant="body2" align="left">
                    {Assets.value} - Bienes
                  </Typography>
                  <Typography fontSize="11px" margin="0" variant="body2" align="left">
                    {formatPercentage(Assets.percentage)} del total
                  </Typography>
                </GridWrapper>
              </GridWrapper>
            </GridWrapper>
            <GridWrapper item xs={12} sm={4}>
              <GridWrapper container alignItems="center">
                <GridWrapper item xs={6}>
                  <DonutChart color="cinnabar" value={Services.percentage} />
                </GridWrapper>
                <GridWrapper item xs={6}>
                  <Typography fontSize="12px" fontWeight="bold" margin="0" variant="body2" align="left">
                    {Services.value} - Servicios
                  </Typography>
                  <Typography fontSize="11px" margin="0" variant="body2" align="left">
                    {formatPercentage(Services.percentage)} del total
                  </Typography>
                </GridWrapper>
              </GridWrapper>
            </GridWrapper>
            <GridWrapper item xs={12} sm={4}>
              <GridWrapper container alignItems="center">
                <GridWrapper item xs={6}>
                  <DonutChart color="cinnabar" value={OtherCat.percentage} />
                </GridWrapper>
                <GridWrapper item xs={6}>
                  <Typography fontSize="12px" fontWeight="bold" margin="0" variant="body2" align="left">
                    {OtherCat.value} - Otros
                  </Typography>
                  <Typography fontSize="11px" margin="0" variant="body2" align="left">
                    {formatPercentage(OtherCat.percentage)} del total
                  </Typography>
                </GridWrapper>
              </GridWrapper>
            </GridWrapper>
          </GridWrapper>
        )}
      </GridWrapper>
      <GridWrapper item xs={12} md={6} align="left">
        <Typography variant="h4" fontSize="16px" fontWeight="bold" align="left">
          Fichas de contrato por ejecución
          <ContractNumberLabel>{contactExecutionTotal}</ContractNumberLabel>
        </Typography>
        {contactExecutionTotal === 0 ? (
          <GridWrapper item xs={12} margin="16px 0 0 0">
            <ContractDivisionNoInfo errorText="No existe información asociada a contratos por ejecución" />
          </GridWrapper>
        ) : (
          <GridWrapper container justifyContent="flex-start" margin="10px auto 0 auto">
            <GridWrapper item xs={12} sm={4}>
              <GridWrapper container alignItems="center">
                <GridWrapper item xs={6}>
                  <DonutChart color="teal" value={Inm.percentage} />
                </GridWrapper>
                <GridWrapper item xs={6}>
                  <Typography fontSize="12px" fontWeight="bold" margin="0" variant="body2">
                    {Inm.value} - Inmediata
                  </Typography>
                  <Typography fontSize="11px" margin="0" variant="body2">
                    {formatPercentage(Inm.percentage)} del total
                  </Typography>
                </GridWrapper>
              </GridWrapper>
            </GridWrapper>
            <GridWrapper item xs={12} sm={4}>
              <GridWrapper container alignItems="center">
                <GridWrapper item xs={6}>
                  <DonutChart color="teal" value={Time.percentage} />
                </GridWrapper>
                <GridWrapper item xs={6}>
                  <Typography fontSize="12px" fontWeight="bold" margin="0" variant="body2">
                    {Time.value} - En el tiempo
                  </Typography>
                  <Typography fontSize="11px" margin="0" variant="body2">
                    {formatPercentage(Time.percentage)} del total
                  </Typography>
                </GridWrapper>
              </GridWrapper>
            </GridWrapper>
            <GridWrapper item xs={12} sm={4}>
              <GridWrapper container alignItems="center">
                <GridWrapper item xs={6}>
                  <DonutChart color="teal" value={OtherEj.percentage} />
                </GridWrapper>
                <GridWrapper item xs={6}>
                  <Typography fontSize="12px" fontWeight="bold" margin="0" variant="body2">
                    {OtherEj.value} - Otros
                  </Typography>
                  <Typography fontSize="11px" margin="0" variant="body2">
                    {formatPercentage(OtherEj.percentage)} del total
                  </Typography>
                </GridWrapper>
              </GridWrapper>
            </GridWrapper>
          </GridWrapper>
        )}
      </GridWrapper>
    </GridWrapper>
  )
}

ContractDivisions.propTypes = {
  year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
}

export default ContractDivisions
